module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/245.120273d2.png";